import { render, staticRenderFns } from "./shelter.vue?vue&type=template&id=94c6f784"
import script from "./shelter.vue?vue&type=script&lang=js"
export * from "./shelter.vue?vue&type=script&lang=js"
import style0 from "./shelter.vue?vue&type=style&index=0&id=94c6f784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports